import { useEffect, useState } from 'react';

import { selectAppServices } from '@vlabs/shared/selectors/appSelectors';
import { useSelector } from 'react-redux';

export const useFaceOcclusionIsAvailable = () => {
  const appServices = useSelector(selectAppServices);
  const versionNum = appServices?.lunaPlatform?.versionNum;

  const [isAvailable, setIsAvailable] = useState(false);

  useEffect(() => {
    if (versionNum) {
      const { major, minor } = versionNum;
      setIsAvailable(major >= 5 && minor >= 84);
    } else {
      setIsAvailable(false);
    }
  }, [versionNum]);

  return isAvailable;
};
